import React, { Component } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
  CardElement,
} from "react-stripe-elements";

import "../checkoutPages.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import amex from "../../../assets/images/cardicons/amex.png";
import discovercard from "../../../assets/images/cardicons/discovercard.png";
import mastercard from "../../../assets/images/cardicons/mastercard.png";
import visa from "../../../assets/images/cardicons/visa.png";

import {
  InputItemsRow,
  InputWrapper,
} from "../../Onboard/Common/Common.styles";

const style = {
  base: {
    lineHeight: "20px",
    color: "#fff",
    fontFamily: "Roboto Condensed",
    fontSize: "16px",
    width: "100%",
    fontWeight: "normal",
    "::placeholder": {
      color: "#999",
      fontWeight: "normal",
      fontSize: "16px",
    },
  },
};
class StripeCheckoutForm extends Component<any> {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  public async submit(ev) {
    ev.preventDefault();
    if (this.props.formFilled()) {
      this.props.StartProcessing();
      const cardEl = this.props.elements.getElement("cardNumber");
      const {
        err,
        paymentMethod,
      } = await this.props.stripe.createPaymentMethod({
        type: "card",
        card: cardEl,
      });
      this.props.onSuccess(paymentMethod.id);
    } else {
      console.log("not all forms filled");
    }
  }

  public handleSuccess(res) {
    toast.success("Great! Now Login In to Performance Learning and Shine");
    this.props.togglePaymentState();
  }

  public handleFail(res) {
    // get error details
    toast.error("Ooops! Failed, try again!");
  }
  public render() {
    return (
      <React.Fragment>
        <div
          style={{
            backgroundColor: "#2d2d2d",
            width: "100%",
            padding: "0 28px 32px 28px",
          }}
        >
          <InputWrapper>
            <p style={{marginBottom: '8px'}}>CARD NUMBER</p>
            <CardNumberElement style={style} />
          </InputWrapper>
          <InputItemsRow>
            <InputWrapper>
              <p style={{marginBottom: '8px'}}>EXPIRY DATE</p>
              <CardExpiryElement style={style} />
            </InputWrapper>
            <InputWrapper>
              <p style={{marginBottom: '8px'}}>cvc</p>
              <CardCVCElement style={style} />
            </InputWrapper>
          </InputItemsRow>
        </div>

        <button
          className="checkout-button green-button"
          type="submit"
          onClick={this.submit}
        >
          Make Payment
        </button>
      </React.Fragment>
    );
  }
}

export default injectStripe(StripeCheckoutForm);



// WEBPACK FOOTER //
// ./src/pages/Subscription/StripeCheckoutForm/StripeCheckoutForm.Component.tsx